import type { HTMLAttributes, ReactNode, Ref } from 'react';
import React from 'react';
import type { AccessibleClickableContainerProps } from '../accessibility';
import { AccessibleClickableContainer } from '../accessibility';

/**
 * Defines the list items, can contain any React.JSX.Elements (e.g. {@link AccessibleClickableContainer})
 */
export interface ListItemProps
  extends Partial<AccessibleClickableContainerProps> {
  children: ReactNode;
  className?: string;
}

export function ListItem({
  ref,
  ...props
}: Readonly<ListItemProps> &
  Pick<HTMLAttributes<HTMLElement>, 'style'> & {
    ref?: Ref<HTMLLIElement>;
  }): React.JSX.Element {
  const classNames = ['ehs-list-item'];
  if (props.className) {
    classNames.push(props.className);
  }
  return props.onClick ? (
    <li ref={ref} className={classNames.join(' ').trim()}>
      <AccessibleClickableContainer
        {...props}
        className="ehs-clickable"
        onClick={props.onClick}
      >
        {props.children}
      </AccessibleClickableContainer>
    </li>
  ) : (
    <li {...props} ref={ref} className={classNames.join(' ').trim()}>
      {props.children}
    </li>
  );
}
